module.exports = __webpack_public_path__ + "static/media/eyescan8.bc0a8f02.png";